import { render, staticRenderFns } from "./AddEditFolder.vue?vue&type=template&id=86fedaae&scoped=true"
import script from "./AddEditFolder.vue?vue&type=script&lang=js"
export * from "./AddEditFolder.vue?vue&type=script&lang=js"
import style0 from "./AddEditFolder.vue?vue&type=style&index=0&id=86fedaae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86fedaae",
  null
  
)

export default component.exports